import React from "react";
import style from "../styles/chat.module.sass"
const Typing = () => {

    return (
        <div className={style.typing_animation}>
            <div className={style.chat_bubble}>
                <div className={style.typing}>
                    <div className={style.type_dot}></div>
                    <div className={style.type_dot}></div>
                    <div className={style.type_dot}></div>
                </div>
            </div>
        </div>

    );
};

export default Typing;